import { createNames } from "../../utils";
export const getAceBackgroundImageNames = (id) => {
    return createNames(id, 'ACE-BACKGROUND-IMAGE', 'CONTENT', 'IMAGE', 'IMAGE____LOADED', 'IMAGE____PLACEHOLDER', 'IMAGE____ANIMATION_DISABLED', 'CONTAINER', 'CONTAINER____BLUR', 'CONTAINER____OVERLAY');
};
//# sourceMappingURL=ace-background-image.get-names.js.map
